/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of rental for real estate property
 * @export
 */
export const RentalTypeEnum = {
    FurnishedLongTerm: 1,
    UnfurnishedRental: 2,
    SeasonalRental: 3,
    StudentRental: 4,
    NotForRent: 5
} as const;
export type RentalTypeEnum = typeof RentalTypeEnum[keyof typeof RentalTypeEnum];


export function instanceOfRentalTypeEnum(value: any): boolean {
    for (const key in RentalTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(RentalTypeEnum, key)) {
            if (RentalTypeEnum[key as keyof typeof RentalTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RentalTypeEnumFromJSON(json: any): RentalTypeEnum {
    return RentalTypeEnumFromJSONTyped(json, false);
}

export function RentalTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): RentalTypeEnum {
    return json as RentalTypeEnum;
}

export function RentalTypeEnumToJSON(value?: RentalTypeEnum | null): any {
    return value as any;
}

export function RentalTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): RentalTypeEnum {
    return value as RentalTypeEnum;
}

